// Pay Model
cv.PayCustomValue = Backbone.Model.extend({
  defaults : {
  },

  initialize: function(){
    console.log('PayCustomValue model loaded.');
  },

  parse: function(response){
    return response;
  }
});

cv.Pay = Backbone.Model.extend({
  defaults : {
    tip: 0,
    first_name : '',
    last_name : '',
    comment : '',
    custom_values : new cv.PayCustomValue(),
    email : '',
    address : '',
    address2 : '',
    city : '',
    state : '',
    zipcode : '',
    country : '',
    giftaid : 1,
    cc_name : '',
    cc_number : '',
    cc_expire_month : '',
    cc_expire_year : '',
    cc_scode : ''
  },

  initialize: function(){
    this.custom_values = this.get('custom_values');

    // If a change event is fired on a nested attribute then we must re-connect the reference
    this.on('change:custom_values', function(model, attr, options){
      this.set('custom_values', this.custom_values);
    }, this);

    console.log('Pay model loaded.');
  }
});

// Results Model
cv.Result = Backbone.RESTModel.extend({
  defaults : {
    photo_path : '',
    name : ''
  },

  initialize: function(){
    console.log('Result model loaded.');
  },

  parse: function(response){
    return response;
  }
});

// PostList Collection
cv.Results = Backbone.Collection.extend({
  initialize: function(options){
    console.log('Result List loaded.');
  },

  url: function() {
    return "/pay/search?" + $.param(this.params);
  },

  model: cv.Result
});
Cocktail.mixin(cv.Results, cv.mixins.PaginateModel);

// Activity Model
Activity = Backbone.Model.extend({
  defaults : {
  },

  initialize: function(){
    console.log('Activity model loaded.');
  },

  parse: function(response){
    console.log(response.activity_id);

    response.meta = $.parseJSON(response.meta);

    return response;
  }
});

// Activity Collection
ActivityList = Backbone.Collection.extend({
  initialize: function(){
    console.log('ActivityList loaded.');
  },

  model: Activity
});

// Editor models
cv.EditorInsert = Backbone.Model.extend({
  defaults: {
  },

  initialize: function(){
    console.log('EditorInsert model loaded.');
  }
});

cv.EditorFigureToolbar = Backbone.Model.extend({
  defaults: {
  },

  initialize: function(){
    console.log('EditorFigureToolbar model loaded.');
  }
});

cv.EditorToolbar = Backbone.Model.extend({
  defaults: {
    bold : false,
    italic : false,
    header : false,
    quote : false,
    link : false,
    align : 'left'
  },

  initialize: function(){
    console.log('EditorToolbar model loaded.');
  }
});

cv.Paragraph = Backbone.Model.extend({
  defaults : {
    text : '',
    markups : [],
    meta : [],
    layout: {
      tag : 'p',
      align : 'left',
      width : 'auto'
    }
  },

  initialize: function(){
    console.log('Paragraph model loaded.');
  }
});

cv.Paragraphs = Backbone.Collection.extend({
  model: cv.Paragraph,

  initialize: function(){
    console.log('Paragraphs collection loaded.');
  }
});
